




































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ModuleBase from './ModuleBase'
import { Module } from '@/models/Module'
import { ModuleDataItem } from '@/models/ModuleDataItem'
import Table from '@/components/Table.vue'
import CardTable from '@/components/CardTable.vue'
import ModuleItemForm from '@/components/ModuleItemForm.vue'
import Modal from '@/components/Modal.vue'
import Confirm from '@/components/Confirm.vue'
import Loader from '@/components/Loader.vue'

interface SingleItemEdit {
	element: object[],
	moduleItem: ModuleDataItem,
}

interface TableRow {
	[key: string]: any
}

@Component({
	components: {
		Table,
		CardTable,
		ModuleItemForm,
		Modal,
		Confirm,
		Loader,
	},
})
export default class ModuleView extends ModuleBase {
	private show: number = 25
	private singleItemEdit: SingleItemEdit = { element: [], moduleItem: new ModuleDataItem() }
	private showEdit: boolean = false
	private showConfirm: boolean = false
	private pageAmountOptions: number[] = [10, 25, 50]
	private pageAmount: number = 10
	private draggable: boolean = false

	get tableView() {
		return this.$store.getters.tableView
	}

	get headers() {
		// console.log(this.module.fields)
		return this.module.fields
	}

	get rows() {
		const selectHeaders = this.headers
			.filter((item: any) => item.type === 'list' || item.type === 'multilist')

		const headers = this.headers
			.filter((heading: any) => heading.main === 1)
			.map((heading: any) => heading.name)
		const rows = this.data.models.map((row: any) => {
			const o: TableRow = {}
			o.id = row.id
			headers.forEach((heading: string) => {
				// Check if 'list' or 'multilist'
				const isSelect = selectHeaders.find((el: any) => el.name === heading)
				if (isSelect && isSelect.type === 'list') {
					// Find value from key and use that as text
					const selectedValue = isSelect.values.find((el: any) => el.key === row[heading])
					if (selectedValue) {
						o[heading] = selectedValue.value
					} else {
						o[heading] = ''
					}
					return
				} else if (isSelect && isSelect.type === 'multilist') {
					// Find values from array of keys and join those as text
					const valueArray: string[] = []
					// Gaurd incase no option selected, not fully tested
					if (!row[heading]) {
						o[heading] = ''
						return
					}
					row[heading].forEach((key: any) => {
						const selectedValue = isSelect.values.find((el: any) => el.key === key)
						if (selectedValue) {
							valueArray.push(selectedValue.value)
						}
					})
					o[heading] = valueArray.join(', ')
					return
				}
				o[heading] = row[heading]
			})
			return o
		})
		return rows
	}

	private reorderRows(oldIndex, newIndex) {
		// https://stackoverflow.com/questions/5306680/move-an-array-element-from-one-array-position-to-another
		// TODO: send change in API
		this.data.models.splice(newIndex, 0, this.data.models.splice(oldIndex, 1)[0])
	}

	private setTableView(view: boolean) {
		this.$store.commit('tableView', view)
	}

	private updateSingleItem(item: ModuleDataItem) {
		item.set('moduleName', this.module.name)
		item.save().then(() => {
			this.$toasted.success('Item updated.')
			this.showEdit = false
		}, (error: any) => {
			this.$toasted.error('Failed to update item.')
			// Reset data
			item.reset()
		})
	}

	private resetSingleItemEdit() {
		if (this.singleItemEdit.moduleItem) {
			this.singleItemEdit.moduleItem.reset()
		}
	}

	private editItem(id: any) {
		if (this.submodule) {
			this.$router.push({ name: 'edit', params: { id, name: this.sub.name }})
			return
		}
		this.$router.push({ name: 'edit', params: { id, name: this.module.name }})
	}

	private confirmDeleteItem(id: number) {
		const confirm = this.$refs.confirm as Confirm
		const deleteItem = this.data.find((item: ModuleDataItem) => item.id === id)
		confirm.create(`This will permanently delete the item.`).then(() => {
			console.log('resolved', deleteItem)
		}, (error) => {
			console.log('rejected', deleteItem)
		})
	}

	private editSingleItem(id: number, name: string) {
		const editArray = this.data.models.filter((item: any) => item.id === id)
		this.singleItemEdit.moduleItem = editArray[0] || null
		this.singleItemEdit.element = this.module.fields.filter((field: any) => field.name === name)
		this.showEdit = true
	}
}
